import React, { useRef } from 'react';

import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import { maskNumber } from '../../helpers/titreHelper';
import { iconsSourcesCustom } from '../../helpers/icons';
import { AnimatePresence, motion } from 'motion/react';

const Message = ({ className, message, setDelay, messagesWrapper, user }) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper
  );

  return (
    <div className={cn(styles.wrapper, className)}>
      {message?.content && (
        <>
          <AnimatePresence mode="wait">
            <div className={styles.blockName} key={`${message.id}-name`}>
              <motion.img
                key={`${message.id}-channel`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                src={
                  iconsSourcesCustom[message.channel] ||
                  iconsSourcesCustom['sms']
                }
                alt={message.channel}
                className={styles.avatar}
              />

              <motion.div
                className={styles.name}
                key={`${message.id}-bgName`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
              >
                {maskNumber(message?.senderNumber, user, message.channel)}
              </motion.div>
            </div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <div className={styles.content} key={message.id}>
              <motion.div
                key={`${message.id}-bg`}
                className={styles.blendMode}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
              />

              <motion.div
                key={`${message.id}-text`}
                className={styles.textWrapper}
                ref={contentContainerRef}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
              >
                <div className={styles.text} ref={contentRef}>
                  {message?.content}
                </div>
              </motion.div>
            </div>
          </AnimatePresence>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
